import { useTranslation } from 'react-i18next';
import BriefCaseLineIcon from '../../../../atoms/icons/BriefCaseLineIcon';
import CakeLineIcon from '../../../../atoms/icons/CakeLineIcon';
import MailLineIcon from '../../../../atoms/icons/MailLineIcon';
import PhoneLineIcon from '../../../../atoms/icons/PhoneLineIcon';
import IconWithText from '../../../../atoms/typography/IconWithText';
import { FontSizeEnum, FontWeightEnum } from '../../../../enums';
import styles from './ContactInformation.module.css';

interface ContactInformationProps {
    readonly birthday?: string;
    readonly email?: string;
    readonly phone?: string;
    readonly employment?: string;
}

const ContactInformation = ({
    birthday,
    email,
    phone,
    employment
}: ContactInformationProps) => {
    const {t} = useTranslation();

    const renderEmployment = () => {
        switch(employment) {
            case 'EMPLOYED_BY_EMPLOYER':
            case 'ENTREPRENEUR':
                return t('candidate.information.employedWithEmployer');
            case 'EMPLOYER':
                return t('candidate.information.unemployed');
            case 'RETIRED':
                return t('candidate.information.pension');
            case 'STUDENT':
                return t('candidate.information.student');
            default:
                return '-';
        }
    }

    return (
        <div className={styles.contactInformation}>
            <IconWithText
                fontSize={FontSizeEnum.Md}
                icon={<CakeLineIcon />}
                fontWeight={FontWeightEnum.Regular}
            >
                {birthday ?? '-'}
            </IconWithText>
            <IconWithText
                fontSize={FontSizeEnum.Md}
                icon={<MailLineIcon />}
                fontWeight={FontWeightEnum.Regular}
            >
                {email ?? '-'}
            </IconWithText>
            <IconWithText
                fontSize={FontSizeEnum.Md}
                icon={<PhoneLineIcon />}
                fontWeight={FontWeightEnum.Regular}
            >
                {phone ?? '-'}
            </IconWithText>
            <IconWithText
                fontSize={FontSizeEnum.Md}
                icon={<BriefCaseLineIcon />}
                fontWeight={FontWeightEnum.Regular}
            >
                {renderEmployment()}
            </IconWithText>
        </div>
    )
}

export default ContactInformation;
